import React, { useRef } from "react"
import cx from "classnames"
import Icon from "@santiment-network/ui/Icon"
import { injectIntl, Link } from "gatsby-plugin-intl"
import AccountBtn from "../AccountBtn/AccountBtn"
import logo from "./images/logo.svg"
import { tr } from "../../utils/translate"
import styles from "./Header.module.scss"

const Header = ({ isAccountPage }) => {
  const toggle = useRef(null)

  const closeNav = () => {
    toggle.current.checked = false
  }

  return (
    <header>
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.products}>
            <img src={logo} alt="sheets logo" />
          </div>
        </div>
        <label htmlFor="hamburger">
          <Icon type="hamburger" />
        </label>
        <input id="hamburger" type="checkbox" ref={toggle} />
        <nav className={styles.nav}>
          <label htmlFor="hamburger" className={styles.close}>
            <Icon type="close" />
          </label>
          <Link className={styles.link} to="/#metrics" onClick={closeNav}>
            {tr("header.metrics")}
          </Link>
          <Link className={styles.link} to="/#use-cases" onClick={closeNav}>
            {tr("header.use_cases")}
          </Link>
          <a
            className={styles.link}
            href="https://app.santiment.net/pricing"
            target="_blank"
            onClick={closeNav}
          >
            {tr("header.pricing")}
          </a>
          <a
            className={cx(styles.link, styles.linkLast)}
            href="mailto:support@santiment.net"
            onClick={closeNav}
          >
            {tr("header.support")}
          </a>
          <AccountBtn isAccountPage={isAccountPage} onClick={closeNav} />
        </nav>
      </div>
    </header>
  )
}
export default injectIntl(Header)
